// 🛠️ AdminPanel.js - FIX COMPLETO
// ✅ Fix: Data creazione visibile
// ✅ Fix: Conteggio partecipanti in tempo reale
// ✅ Fix: Auto-refresh ogni 5 secondi

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';

// ✅ Normalizza URL API
function getApiUrl() {
  let url = process.env.REACT_APP_SERVER_URL || 'http://localhost:5000';
  url = url.replace(/\/$/, '');
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    url = `https://${url}`;
  }
  console.log('🔧 API_URL configurato:', url);
  return url;
}

const API_URL = getApiUrl();

// ... (mantieni tutti gli styled components esistenti)

const PageContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  padding: 2rem;
`;

const AdminContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 3rem;
`;

const Title = styled.h1`
  color: white;
  font-size: 2.5rem;
  font-weight: 800;
  margin: 0;
`;

const HeaderActions = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
`;

const RefreshButton = styled(motion.button)`
  padding: 0.9rem 1.8rem;
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  border: none;
  border-radius: 12px;
  color: white;
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const LogoutButton = styled(motion.button)`
  padding: 0.9rem 1.8rem;
  background: linear-gradient(135deg, #ef4444, #dc2626);
  border: none;
  border-radius: 12px;
  color: white;
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
`;

const LoginContainer = styled.div`
  max-width: 450px;
  margin: 5rem auto;
  background: rgba(255, 255, 255, 0.05);
  padding: 3rem;
  border-radius: 20px;
  border: 2px solid rgba(255, 107, 53, 0.3);
`;

const LoginTitle = styled.h2`
  color: white;
  font-size: 2rem;
  margin-bottom: 2rem;
  text-align: center;
`;

const Input = styled.input`
  width: 100%;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  color: white;
  font-size: 1rem;
  margin-bottom: 1.5rem;
  
  &:focus {
    outline: none;
    border-color: #FF6B35;
  }
`;

const LoginButton = styled(motion.button)`
  width: 100%;
  padding: 1rem;
  background: linear-gradient(135deg, #FF6B35, #F7931E);
  border: none;
  border-radius: 10px;
  color: white;
  font-weight: 700;
  font-size: 1.1rem;
  cursor: pointer;
`;

const ErrorMessage = styled.div`
  background: rgba(239, 68, 68, 0.2);
  border: 2px solid rgba(239, 68, 68, 0.5);
  color: #ef4444;
  padding: 1rem;
  border-radius: 10px;
  margin-bottom: 1.5rem;
  text-align: center;
  font-weight: 600;
`;

const SuccessMessage = styled.div`
  background: rgba(16, 185, 129, 0.2);
  border: 2px solid rgba(16, 185, 129, 0.5);
  color: #10b981;
  padding: 1rem;
  border-radius: 10px;
  margin-bottom: 1.5rem;
  text-align: center;
  font-weight: 600;
`;

const Section = styled(motion.div)`
  background: rgba(255, 255, 255, 0.05);
  padding: 2.5rem;
  border-radius: 20px;
  border: 2px solid rgba(255, 107, 53, 0.3);
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
  color: white;
  font-size: 1.8rem;
  margin-bottom: 2rem;
`;

const Form = styled.form`
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(3, 1fr);
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const Label = styled.label`
  color: rgba(255, 255, 255, 0.9);
  font-weight: 600;
`;

const FormInput = styled.input`
  padding: 0.9rem;
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  color: white;
  font-size: 1rem;
  
  &:focus {
    outline: none;
    border-color: #FF6B35;
  }
`;

const CreateButton = styled(motion.button)`
  padding: 1rem 2rem;
  background: linear-gradient(135deg, #10b981, #059669);
  border: none;
  border-radius: 10px;
  color: white;
  font-weight: 700;
  font-size: 1.05rem;
  cursor: pointer;
  grid-column: span 3;
  
  @media (max-width: 768px) {
    grid-column: span 1;
  }
`;

const RoomsList = styled.div`
  display: grid;
  gap: 1.5rem;
`;

const RoomCard = styled(motion.div)`
  background: linear-gradient(135deg, rgba(255, 107, 53, 0.05), rgba(247, 147, 30, 0.05));
  border: 2px solid rgba(255, 107, 53, 0.2);
  border-radius: 16px;
  padding: 2rem;
`;

const RoomName = styled.h3`
  color: white;
  font-size: 1.4rem;
  margin: 0 0 1rem 0;
  font-weight: 700;
`;

const RoomMeta = styled.div`
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.95rem;
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-bottom: 1rem;
`;

const LinkDisplay = styled.div`
  background: rgba(0, 0, 0, 0.4);
  border: 2px solid rgba(255, 107, 53, 0.3);
  border-radius: 10px;
  padding: 0.8rem 1rem;
  font-family: 'Monaco', monospace;
  font-size: 0.85rem;
  color: #FF6B35;
  word-break: break-all;
  margin: 1rem 0;
`;

const RoomActions = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.75rem;
  margin-top: 1rem;
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const JoinButton = styled.button`
  padding: 0.9rem 1rem;
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  
  &:hover {
    transform: translateY(-2px);
  }
`;

const CopyButton = styled.button`
  padding: 0.9rem 1rem;
  background: linear-gradient(135deg, #FF6B35, #F7931E);
  color: white;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  
  &:hover {
    transform: translateY(-2px);
  }
`;

const ShareButton = styled.button`
  padding: 0.9rem 1rem;
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: white;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  
  &:hover {
    transform: translateY(-2px);
  }
`;

const DeleteButton = styled.button`
  padding: 0.9rem 1rem;
  background: linear-gradient(135deg, #ef4444, #dc2626);
  color: white;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  
  &:hover {
    transform: translateY(-2px);
  }
`;

const Toast = styled(motion.div)`
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  background: ${props => props.type === 'success' ? 'linear-gradient(135deg, #10b981, #059669)' : 'linear-gradient(135deg, #ef4444, #dc2626)'};
  color: white;
  padding: 1rem 1.5rem;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-weight: 600;
  z-index: 10000;
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 4rem 2rem;
  color: rgba(255, 255, 255, 0.6);
  font-size: 1.1rem;
`;

const LastUpdate = styled.div`
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.85rem;
  text-align: center;
  margin-top: 1rem;
`;

function AdminPanel() {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ name: '', password: '', maxParticipants: 50 });
  const [createError, setCreateError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [toast, setToast] = useState(null);
  const [lastUpdate, setLastUpdate] = useState(null);

  const showToast = (message, type = 'success') => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3000);
  };

  const generateRoomLink = (roomId) => {
    return `${window.location.origin}/join/${roomId}`;
  };

  const handleJoinRoom = (roomId) => {
    const displayName = localStorage.getItem('displayName') || 'Admin';
    navigate(`/room/${roomId}`, {
      state: { displayName, videoEnabled: true, audioEnabled: true, role: 'host' }
    });
  };

  const handleCopyLink = async (roomId, roomName) => {
    const link = generateRoomLink(roomId);
    try {
      await navigator.clipboard.writeText(link);
      showToast(`✅ Link copiato: ${roomName}`, 'success');
    } catch (error) {
      showToast('❌ Errore copia link', 'error');
    }
  };

  const handleShareLink = async (roomId, roomName) => {
    const link = generateRoomLink(roomId);
    if (navigator.share) {
      try {
        await navigator.share({
          title: `LuminAI Connect - ${roomName}`,
          text: `Unisciti alla sala: ${roomName}`,
          url: link
        });
        showToast('✅ Link condiviso!', 'success');
      } catch (error) {
        if (error.name !== 'AbortError') {
          handleCopyLink(roomId, roomName);
        }
      }
    } else {
      handleCopyLink(roomId, roomName);
    }
  };

  // ✅ Formatta data in italiano
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (error) {
      return 'N/A';
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      setIsAuthenticated(true);
      loadRooms();
    }
  }, []);

  // ✅ Auto-refresh ogni 5 secondi
  useEffect(() => {
    if (!isAuthenticated) return;

    const interval = setInterval(() => {
      console.log('🔄 Auto-refresh sale...');
      loadRooms(true); // true = silent refresh (no loading spinner)
    }, 5000); // 5 secondi

    return () => clearInterval(interval);
  }, [isAuthenticated]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setLoginError('');

    console.log('🔐 Tentativo login a:', API_URL);

    try {
      const response = await fetch(`${API_URL}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      });

      console.log('📡 Risposta login:', response.status);

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('adminToken', data.token);
        setIsAuthenticated(true);
        loadRooms();
      } else {
        setLoginError(data.message || 'Password errata');
      }
    } catch (error) {
      console.error('❌ Errore login:', error);
      setLoginError('Errore di connessione al server');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    setIsAuthenticated(false);
    navigate('/');
  };

  const loadRooms = async (silent = false) => {
    if (!silent) setLoading(true);
    
    try {
      const token = localStorage.getItem('adminToken');
      const response = await fetch(`${API_URL}/api/admin/rooms`, {
        headers: { 'Authorization': `Bearer ${token}` },
      });

      if (response.ok) {
        const data = await response.json();
        console.log('📋 Sale caricate:', data.rooms);
        setRooms(data.rooms || []);
        setLastUpdate(new Date());
      }
    } catch (error) {
      console.error('❌ Errore caricamento sale:', error);
    } finally {
      if (!silent) setLoading(false);
    }
  };

  const handleCreateRoom = async (e) => {
    e.preventDefault();
    setLoading(true);
    setCreateError('');
    setSuccessMessage('');

    try {
      const token = localStorage.getItem('adminToken');
      const response = await fetch(`${API_URL}/api/admin/rooms`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccessMessage(`✅ Sala "${formData.name}" creata!`);
        setFormData({ name: '', password: '', maxParticipants: 50 });
        loadRooms();
        showToast(`✅ Sala creata!`, 'success');
      } else {
        setCreateError(data.message || 'Errore creazione');
      }
    } catch (error) {
      setCreateError('Errore di connessione');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteRoom = async (roomId, roomName) => {
    if (!window.confirm(`Eliminare "${roomName}"?`)) return;
    try {
      const token = localStorage.getItem('adminToken');
      const response = await fetch(`${API_URL}/api/admin/rooms/${roomId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` },
      });
      if (response.ok) {
        showToast(`✅ Sala eliminata`, 'success');
        loadRooms();
      } else {
        showToast('❌ Errore eliminazione', 'error');
      }
    } catch (error) {
      showToast('❌ Errore di connessione', 'error');
    }
  };

  if (!isAuthenticated) {
    return (
      <PageContainer>
        <LoginContainer>
          <LoginTitle>🔐 Admin Login</LoginTitle>
          {loginError && <ErrorMessage>{loginError}</ErrorMessage>}
          <form onSubmit={handleLogin}>
            <Input type="password" placeholder="Password Admin" value={password} onChange={(e) => setPassword(e.target.value)} required />
            <LoginButton type="submit" disabled={loading}>{loading ? 'Accesso...' : '🚀 Accedi'}</LoginButton>
          </form>
        </LoginContainer>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <AdminContainer>
        <Header>
          <Title>🛠️ Admin Panel</Title>
          <HeaderActions>
            <RefreshButton onClick={() => loadRooms()} whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              🔄 Aggiorna
            </RefreshButton>
            <LogoutButton onClick={handleLogout}>👋 Esci</LogoutButton>
          </HeaderActions>
        </Header>

        <Section>
          <SectionTitle>➕ Crea Sala</SectionTitle>
          {createError && <ErrorMessage>{createError}</ErrorMessage>}
          {successMessage && <SuccessMessage>{successMessage}</SuccessMessage>}
          <Form onSubmit={handleCreateRoom}>
            <FormGroup>
              <Label>Nome Sala *</Label>
              <FormInput type="text" placeholder="es. Riunione Team" value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} required />
            </FormGroup>
            <FormGroup>
              <Label>Password</Label>
              <FormInput type="text" placeholder="Opzionale" value={formData.password} onChange={(e) => setFormData({...formData, password: e.target.value})} />
            </FormGroup>
            <FormGroup>
              <Label>Max Partecipanti</Label>
              <FormInput type="number" min="2" max="100" value={formData.maxParticipants} onChange={(e) => setFormData({...formData, maxParticipants: parseInt(e.target.value)})} required />
            </FormGroup>
            <CreateButton type="submit" disabled={loading}>{loading ? '⏳ Creazione...' : '✨ Crea'}</CreateButton>
          </Form>
        </Section>

        <Section>
          <SectionTitle>📋 Sale Attive ({rooms.length})</SectionTitle>
          {rooms.length === 0 ? (
            <EmptyState>Nessuna sala creata</EmptyState>
          ) : (
            <>
              <RoomsList>
                {rooms.map((room) => (
                  <RoomCard key={room.id}>
                    <RoomName>{room.name} {room.password && '🔒'}</RoomName>
                    <RoomMeta>
                      <span>🆔 {room.id}</span>
                      <span>👤 {room.activeParticipants || 0}/{room.max_participants}</span>
                      <span>📅 {formatDate(room.created_at)}</span>
                    </RoomMeta>

                    <LinkDisplay>{generateRoomLink(room.id)}</LinkDisplay>

                    <RoomActions>
                      <JoinButton onClick={() => handleJoinRoom(room.id)}>🚪 Entra</JoinButton>
                      <CopyButton onClick={() => handleCopyLink(room.id, room.name)}>📋 Copia</CopyButton>
                      <ShareButton onClick={() => handleShareLink(room.id, room.name)}>📤 Condividi</ShareButton>
                      <DeleteButton onClick={() => handleDeleteRoom(room.id, room.name)}>🗑️ Elimina</DeleteButton>
                    </RoomActions>
                  </RoomCard>
                ))}
              </RoomsList>
              {lastUpdate && (
                <LastUpdate>
                  Ultimo aggiornamento: {formatDate(lastUpdate)}
                </LastUpdate>
              )}
            </>
          )}
        </Section>
      </AdminContainer>

      <AnimatePresence>
        {toast && (
          <Toast type={toast.type} initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}>
            <span>{toast.type === 'success' ? '✅' : '❌'}</span>
            <span>{toast.message}</span>
          </Toast>
        )}
      </AnimatePresence>
    </PageContainer>
  );
}

export default AdminPanel;
